"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CharacteristicStateSummaryExternalSchema = void 0;
const zod_1 = require("zod");
const BoundaryCharacteristic_1 = require("../BoundaryCharacteristic");
const CharacteristicValue_1 = require("./CharacteristicValue");
exports.CharacteristicStateSummaryExternalSchema = zod_1.default.object({
    characteristic: zod_1.default.lazy(() => BoundaryCharacteristic_1.BoundaryCharacteristicSchema),
    value: zod_1.default.lazy(() => CharacteristicValue_1.CharacteristicValueSchema),
});
//# sourceMappingURL=CharacteristicStateSummaryExternal.js.map